import styled from "styled-components";
import { Button } from "../ui";

export const ModalReminder = ({
  children,
  showModal,
  setShowModal,
  title,
  handleSubmitRef,
  textButton,
  reminder,
  ...otherProps
}) => {
  return (
    <>
      <Container>
        <Title>
          {" "}
          Siniestro #{String(reminder.numeroSiniestro).padStart(4, "0")}
        </Title>

        <FormContainer onSubmit={handleSubmitRef}>
          <DateContainer>
            Fecha programada: {reminder?.fecha.split("T")[0]}
          </DateContainer>
          <Property>
            Nota de seguimiento: <span>{reminder?.notaSeguimiento}</span>
          </Property>
          <Property>
            {reminder?.documentales?.length > 0 ? "Archivos: " : ""}
            {reminder?.documentales?.map((doc, index) => {
              return (
                <span>
                  <a href={doc?.url} target="_blank" rel="noreferrer">
                    {doc?.nombre_archivo}
                  </a>{" "}
                  ,
                </span>
              );
            })}
          </Property>
          <ButtonsContainer>
            <Button
              text={"Marcar como revisado"}
              type="button"
              onClick={() => handleSubmitRef({ redirect: false })}
              style={{ borderRadius: "20px", flex: 1 , width: "100%"}}
            />
            <Button
              text={"Marcar como revisado y agregar nuevo seguimiento"}
              color="var(--secondary-forest-green)"
              style={{ borderRadius: "20px", flex: 2, width: "100%" }}
              outlined
              type="button"
              onClick={() => handleSubmitRef({ redirect: true })}
            />
          </ButtonsContainer>
        </FormContainer>
      </Container>
    </>
  );
};

const Container = styled.div``;

const DateContainer = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: var(--neutrals-light-gray);
  margin-bottom: 10px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 20px;
  @media (max-width: 426px) {
    flex-direction: column;
    gap: 10px;
  }
`;

const Property = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: var(--neutrals-slate-gray);
  & span {
    font-weight: 500;
  }
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 12px;
  text-align: left;
`;

const FormContainer = styled.form``;
